import { compose } from 'ramda';
import { get, post } from './http';
import { batchParse } from './bone';
import config from '../config';

const API_PREFIX = 'api/ev-spaceship';

const url = (url: string) => (props: any = {}) => ({ url, ...props });

/**
 * 获取应用信息
 */
export const getApp = (id: string) => get({ url: `${API_PREFIX}/app/${id}` });

/**
 * 获取发布页大屏列表
 */
export const getScreens = compose(get, url(`${API_PREFIX}/screens`));

/**
 * 获取大屏链接
 * /scren/:id
 */
export const getScreenLink = (screenId: string) => get({ url: `${API_PREFIX}/screen/${screenId}` });

/**
 * 获取大屏管理列表
 */
export const getAllScreens = compose(
  (rep) =>
    rep.then((list) =>
      batchParse(
        {
          id: 'id',
          title: 'name',
          image: {
            key: 'thumb',
            default: config.DEFAULT_COVER
            // item.image ? config.ASSETS_URL + item.image : config.DEFAULT_COVER
          },
          show: 'published',
          publishTime: 'publishedAt'
        },
        list
      )
    ),
  get,
  url(`${API_PREFIX}/screens/all`)
);

/**
 * 更新大屏
 */
export const updateScreen = (screenId: string, data: any) =>
  post({ url: `${API_PREFIX}/screen/${screenId}`, data, option: { formdata: true } });

/**
 * 更新应用
 */
export const updateStyle = (data: any) => post({ url: `${API_PREFIX}/app`, data, option: { formdata: true } });

/**
 * 恢复样式
 */
export const resetStyle = (data: any) => post({ url: `${API_PREFIX}/app/restore`, data });
